
import { defineComponent, watchEffect } from "vue";

export default defineComponent({
  name: "OrderCard",
  props: ["orders"],

  data() {
    return {
      words: ["пассажир", "пассажира", "пассажиров"],
      activeOrder: null,
    };
  },
  methods: {
    getWeekDay(date: any) {
      let days = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"];
      let weekDay = new Date(date);
      return days[weekDay.getDay()];
    },
    getDate(date: any) {
      let month = [
        "Января",
        "Февраля",
        "Марта",
        "Апреля",
        "Мая",
        "Июня",
        "Июля",
        "Августа",
        "Сентября",
        "Октября",
        "Ноября",
        "Декабря",
      ];
      let monthNum = new Date(date);
      return monthNum.getDate() + " " + month[monthNum.getMonth()];
    },
    declOfNum(number: any, words: any) {
      return words[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : [2, 0, 1, 1, 1, 2][number % 10 < 5 ? Math.abs(number) % 10 : 5]
      ];
    },
    wordWraper(word: string): string {
      const position = word.indexOf("(");
      if (position !== -1) {
        const newWord = word.slice(0, position);
        return newWord;
      } else {
        return word;
      }
    },
  },
  created() {
    watchEffect(() => {
      this.activeOrder = this.orders;
    });
  },
});
